import React from 'react';
import { Link } from 'react-router-dom';
import ThemeToggle from './ThemeToggle';

export default function AppHeader({ title }) {
  return (
    <header className="app-header">
      <Link to="/" className="app-header-back" aria-label="Voltar para med41">
        ←
      </Link>

      <h1 className="app-header-title">
        {title}
      </h1>

      <ThemeToggle />
    </header>
  );
}